<div [class.reportviewWindow]="opened">
  @if (!opened) {
    <div>
      @if (reportParent === 'custom') {
        <div class="sample-watermark">
          <div class="sample-watermark__text">Sample</div>
        </div>
      }
      <div>
        @if (_showFilter == true || _showEmail == true) {
          <div style="margin-left: 2%;">
            @if (_showFilter == true) {
              <div>
                <div style="display:flex;" class="dropdown-button" (click)="toggleFilter()">
                  <span>Show Filter</span>
                  <div class="dropdown-arrow">&#9660;</div>
                </div>
                @if (isFilterVisible == true) {
                  <div class="filtersDiv">
                    <fieldset class="report">
                      <legend style="font-size: 1em;">Filter</legend>
                      <div class="col-12 zeroPaddingColumn">
                        @if (_selectedReportDateFields.length > 0) {
                          <input type="checkbox"
                            class="k-checkbox"
                            id="dateRangeFilter"
                            [(ngModel)]="dateRangeFilter"
                            kendoCheckBox />
                        }
                        @if (_selectedReportDateFields.length > 0) {
                          <label for="dateRangeFilter" class="control-label">Date Range Filter</label>
                        }
                        @if (dateRangeFilter == true) {
                          <div>
                            <div class="row">
                              <div class="col-md-3">
                                <label>Criteria</label>
                                <kendo-combobox #selectBy
                                  [clearButton]="false"
                                  [filterable]="true"
                                  [data]="_selectedReportDateFields"
                                  textField="title"
                                  valueField="field"
                                  class="current-step new-combo-width"
                                  [(ngModel)]="dateRangeFilterField">
                                </kendo-combobox>
                              </div>
                              <div class="col-md-9">
                                <div class="combobox_contaainer_small">
                                  <label>From</label>
                                  <kendo-datetimepicker #datetime
                                    [(ngModel)]="fromDateRange"
                                    placeholder="Set Date - Time"
                                    [format]="_datePickerFormat"
                                    class="bordered"
                                    style="width:300px;">
                                  </kendo-datetimepicker>
                                </div>
                                <div class="combobox_contaainer_small">
                                  <label>To</label>
                                  <kendo-datetimepicker #datetime
                                    [(ngModel)]="toDateRange"
                                    placeholder="Set Date - Time"
                                    [format]="_datePickerFormat"
                                    class="bordered"
                                    style="width:300px;">
                                  </kendo-datetimepicker>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                      <div class="col-12 zeroPaddingColumn">
                        @if (_selectedReportNotDateFields.length > 0) {
                          <input type="checkbox"
                            class="k-checkbox"
                            id="dateFieldFilter"
                            [(ngModel)]="dataFieldFilter"
                            kendoCheckBox />
                        }
                        <label for="dateFieldFilter" class="control-label">Data Field Filter </label>
                        @if (dataFieldFilter == true) {
                          <div>
                            @for (item of filterCriteriaHtml; track item; let i = $index) {
                              <div style="margin-left: 1%;" class="row">
                                <div class="col-md-12">
                                  <label>Select:</label>
                                  <kendo-combobox style="width:10%" #selectBy
                                    [clearButton]="false"
                                    [filterable]="true"
                                    [data]="_selectedReportNotDateFields"
                                    textField="title"
                                    valueField="field"
                                    class="current-step new-combo-width"
                                    [(ngModel)]="item.field">
                                  </kendo-combobox>
                                  <kendo-combobox style="width:10%"
                                    [filterable]="true"
                                    [data]="filterType"
                                    textField="type"
                                    valueField="type"
                                    class="current-step new-combo-width"
                                    [(ngModel)]="item.operator">
                                  </kendo-combobox>
                                  <input style="width:10%" type="text" [(ngModel)]="item.value" class="k-textbox writebox min-width-0" />
                                  @if (i != (filterCriteriaHtml.length - 1)) {
                                    <kendo-combobox
                                      style="width:10%"
                                      [clearButton]="false"
                                      [filterable]="true"
                                      [data]="operators"
                                      textField="operator"
                                      valueField="operator"
                                      class="current-step new-combo-width"
                                      [(ngModel)]="item.logicalOperator">
                                    </kendo-combobox>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="col-12 zeroPaddingColumn">
                        <input type="checkbox"
                          class="k-checkbox"
                          id="reportSorting"
                          [(ngModel)]="reportSorting"
                          kendoCheckBox />
                          <label for="reportSorting" class="control-label">Report Sorting </label>
                          @if (reportSorting == true) {
                            <div class="col-12 col-md-6 stepsColPadding">
                              <div class="row">
                    <div class="col-12
                " style="display: inline-flex;">
                                  @if (_selectedReportFields) {
                                    <asap-fields-select-from-boxes class="select-boxes"
                                      [fields]="_selectedReportFields"
                                      [selectedFields]="_selectedReportSortFields"
                                      (selectedFieldsOutput)="_onChangeSortSelectedFields($event)"
                                      [displayFieldName]="'title'"
                                      [title]="'Fields'"
                                      [fullWidth]="true"
                                      [max10Items]="true"
                                      [showFilters]="true"
                                      [withPrimary]="false"
                                      [withCustomCheckBox]="true"
                                      (customCheckBoxOutput)="getCustomCheckBoxSelected($event)">
                                      style="width: 150%;"
                                    </asap-fields-select-from-boxes>
                                  }
                                  <label style="margin-top: 15%;">Checkbox Reverses the Sort Order</label>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                        <div class="row">
                          <div class="col-12" style="margin-top:10px">
                            <button (click)="applySortingAndFiltering(selectedSortField, filterValue)" kendoButton class="steps_buttons_class">
                              <img class="backimage" [src]="'/assets/menu/'+ theme +'/save-icon-group.svg'" />
                              <span>Process</span>
                            </button>
                            <button kendoButton class="steps_buttons_class"
                              (click)="clearFiltering()">
                              <img class="backimage" [src]="'/assets/menu/'+ theme +'/close-schedule-report-icon-green.svg'" />
                              <span>Clear</span>
                            </button>
                          </div>
                        </div>
                      </fieldset>
                    </div>
                  }
                </div>
              }
              @if (_showEmail == true) {
                <div>
                  <div style="display:flex;" class="dropdown-button" (click)="toggleEmail()">
                    <span>Show Email</span>
                    <div class="dropdown-arrow">&#9660;</div>
                  </div>
                  @if (isShowEmailVisible == true) {
                    <div class="filtersDiv">
                      <fieldset class="report">
                        <legend style="font-size: 1em;">Email</legend>
                        <div class="col-6 zeroPaddingColumn">
                          <label>To Address:</label>
                          <input style="width:80%" type="text" [(ngModel)]="emailsToSend" class="k-textbox writebox min-width-0" />
                          <button (click)="sendEmail(emailsToSend)" kendoButton class="steps_buttons_class">
                            <img class="backimage" [src]="'/assets/menu/'+ theme +'/save-icon-group.svg'" />
                            <span>Send</span>
                          </button>
                          <br />
                          <span style="color:red;">*Add multiple emails seperated by comma (,)</span>
                        </div>
                      </fieldset>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div id="viewer" [class.previewMode]="!_windowMode"></div>
        </div>
        @if (opened) {
          <div>
            <form novalidate [formGroup]="editForm" class="form_style">
              <div class="row enterpsriseRowStyle margin_top_8">
                <div class="col-12">
                  <div class="mainReportsContainer">
                    <div class="row">
                      <div class="k-block noborder_buttom">
                        <h2 class="smalHeight">Forecast Month To Month</h2>
                        <div class="right_buttons">
                          <br />
                          <div class="row bottom_buttons">
                            <div class="col-xs-12">
                              <button kendoButton (click)="close('no')">
                                <span>
                                  <img [src]="'/assets/menu/'+ theme +'/save-close-icon.svg'" />
                                </span>Generate Report
                              </button>
                              <button kendoButton (click)="close('yes')" themeColor="primary">
                                <span><img [src]="'/assets/menu/'+ theme +'/close-icon.svg'" /></span><span class="hidden-xs">Close</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="borderSeperator"> </div>
                      </div>
                      <div class="col-12">
                        <div class="row">
                          <div class="col-12">
                            <div class="rtClass">
                              Choose which account you would like to forecast
                            </div>
                          </div>
                          <div class="col-12 col-md-6 margin-top-10">
                            <div class="form-group special_style_formgroup">
                              <kendo-combobox class="dropdown-list-style"
                                formControlName="selectedAccount"
                                [data]="listaccounts" [textField]="'name'" [valueField]="'id'">
                              </kendo-combobox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row enterpsriseRowStyle margin_top_8">
                <div class="col-12">
                  <div class="mainReportsContainer">
                    <div class="row">
                      <div class="col-8 d-flex margin-top-10">
                        <label for="ForecastDate" class="control-label">Forecast Date</label>
                        <kendo-datetimepicker class="full-width" (valueChange)="onForecastDateChange($event)"
                          formControlName="ForecastDate" [format]="'MMMM yyyy'" [value]="ForecastDateValue">
                        </kendo-datetimepicker>
                      </div>
                      <div class="col-8 d-flex margin-top-10">
                        <label for="providedDate" class="control-label">Target Date</label>
                        <kendo-datetimepicker class="full-width" (valueChange)="onProvidedDateChange($event)"
                          formControlName="providedDate" [format]="'MMMM yyyy'" [value]="providedDateValue">
                        </kendo-datetimepicker>
                      </div>
                      <div class="col-8 d-flex margin-top-10">
                        <label for="overage" class="control-label">Overage/Shrinkage*</label>
                        <kendo-numerictextbox class="full-width" type="text" formControlName="overage">
                        </kendo-numerictextbox>
                        <br />
                        <span class="numericBoxDescription">*For shrinkage use a negative value</span>
                      </div>
                      <div class="col-8 d-flex margin-top-20">
                        <label for="replenish" class="control-label">Replenish</label>
                        <kendo-numerictextbox class="full-width" type="text" formControlName="replenish">
                        </kendo-numerictextbox>
                      </div>
                      <div class="col-8 d-flex margin-top-10">
                        <label class="control-label">Condition Name</label>
                        <input #input class="k-textbox writebox full-width" formControlName="conditionName">
                      </div>
                      <div class="col-8 d-flex margin-top-10">
                        <label class="control-label">Initial Value</label>
                        <kendo-numerictextbox class="full-width" type="text" formControlName="initialValue">
                        </kendo-numerictextbox>
                      </div>
                      <div class="col-8 d-flex margin-top-10">
                        <label class="control-label">Targeted Value</label>
                        <kendo-numerictextbox class="full-width" type="text" formControlName="targetedValue">
                        </kendo-numerictextbox>
                      </div>
                      <div class="col-8 d-flex margin-top-10">
                        <label class="control-label">With Burn Rate</label>
                        <input type="checkbox" class="k-checkbox full-width" kendoCheckBox formControlName="withBurnRate" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!--<customfields [customFieldDisplay]="reportParams" [reportForm]="reportParams" (returnCustomFields)="returnCustomFields($event)" [model]="reportParams"></customfields>-->
            <!-- <button kendoButton (click)="close('no')">Generate Report</button>
            <button kendoButton (click)="close('yes')" primary="true">Cancel</button> -->
          </div>
        }
      </div>
    }
